<template>
  <div>
    <common-table
      :url="url"
      :table-columns="tableColumns"
      :form-fields="formFields"
      :operate="operate"
      :permission="permission"
      :searchs="searchs"
      :buttons="buttons"
      :auto-update="true"
      ref="table"
    >
    </common-table>
    <div class="dialog">
      <el-dialog
        title="选择导出时间"
        :visible.sync="exportVisible"
        custom-class="common-dialog"
        :close-on-click-modal="false"
        @close="resetForm('form')"
        width="30%"
      >
        <div class="dialog_body">
          <el-form
            label-position="right"
            status-icon
            label-width="90px"
            :model="form"
            ref="form"
          >
            <el-form-item
              label="代理"
              prop="agentId"
              :rules="[
                { message: '请选择代理', trigger: 'blur', required: false },
              ]"
            >
              <el-select
                filterable
                v-model="form.agentId"
                clearable
                placeholder="请选择代理"
                size="medium"
                class="mr10 mb-10"
              >
                <el-option
                  v-for="(option, index) in agents"
                  :key="index"
                  :label="option.name"
                  :value="option.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="开始时间"
              prop="startTime"
              :rules="[
                { message: '请选择开始时间', trigger: 'blur', required: true },
              ]"
            >
              <el-date-picker
                v-model="form.startTime"
                placeholder="开始时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                align="right"
                size="medium"
                class="mr10 mb-10"
              />
            </el-form-item>
            <el-form-item
              label="结束时间"
              prop="endTime"
              :rules="[
                { message: '请选择结束时间', trigger: 'blur', required: true },
              ]"
            >
              <el-date-picker
                v-model="form.endTime"
                placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                align="right"
                size="medium"
                class="mr10 mb-10"
              />
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="exportVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" size="small" @click="submit('form')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable/CommonTable'
import request from '@/utils/axios.js'
import message from '../../utils/message'
//import {excelDownload} from "../../utils/download";
// import axios from 'axios'
export default {
  name: 'UsdtFee',
  components: { CommonTable },
  data() {
    return {
      exportVisible: false,
      form: {
        startTime: '',
        endTime: '',
        agentId: '',
      },
      agents: [],
      searchs: [
        {
          name: 'agentId',
          placeholder: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
        },
        {
          name: 'rechargeId',
          placeholder: '充值订单号',
          type: 'input',
        },
        {
          name: 'type',
          placeholder: '类型',
          type: 'select',
          selectValue: [
            {
              key: 1,
              value: '转出',
            },
            {
              key: 2,
              value: '归集',
            },{
              key: 3,
              value: '归集能量',
            },
            {
              key: 4,
              value: '提现能量',
            },
          ],
        },
        {
          name: 'status',
          placeholder: '请选择状态',
          type: 'select',
          selectValue: [
            {
              key: 1,
              value: '成功',
            },
            {
              key: 2,
              value: '转账中',
            },
          ],
        },
        {
          name: 'startTime',
          placeholder: '开始时间',
          type: 'dateTime',
        },
        {
          name: 'endTime',
          placeholder: '结束时间',
          type: 'dateTime',
        },
      ],
      permission: {
        //add: 'recharge:add',
        //update: 'recharge:update',
        //delete: 'recharge:delete',
        //deleteBatch: 'recharge:deleteBatch'
      },
      url: {
        get: '/usdtFee/listByCondition',
        //add: '/recharge/add',
        //update: '/recharge/update',
        //delete: '/recharge/delete/',
        //delete_batch: '/recharge/deleteBatch',
      },
      tableColumns: [
        {
          field: 'id',
          label: 'ID',
          show: true,
          detail: true,
          width: '',
        },
        {
          field: 'agentId',
          label: '代理',
          selectUrl: '/agent/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
          detail: false,
          width: '',
        },
        {
          field: 'rechargeId',
          label: '充值ID',
          show: true,
          detail: false,
          width: '',
        },
        {
          field: 'fromAddress',
          label: '出款地址',
          show: true,
          detail: false,
          width: '',
        },
        {
          field: 'toAddress',
          label: '收款地址',
          show: true,
          detail: false,
          width: '',
        },
        {
          field: 'amount',
          label: '金额(TRX)',
          show: true,
          detail: false,
          width: '',
        },
        {
          field: 'type',
          label: '类型',
          show: {
            type: 'tag',
            tags: [
              {
                key: 1,
                value: '转出',
              },
              {
                key: 2,
                value: '归集',
              },{
                key: 3,
                value: '归集能量',
              },
              {
                key: 4,
                value: '提现能量',
              }
            ],
          },
          detail: false,
          width: '',
          selectData: [
            {
              id: 1,
              name: '转出',
            },
            {
              id: 2,
              name: '归集',
            },{
              key: 3,
              value: '归集能量',
            },
            {
              key: 4,
              value: '提现能量',
            }
          ],
        },
        {
          field: 'txId',
          label: '交易ID',
          show: true,
          detail: false,
          width: '',
        },
        {
          field: 'status',
          label: '状态',
          show: {
            type: 'tag',
            tags: [
              {
                key: 1,
                value: '成功',
                type: 'success',
              },
              {
                key: 2,
                value: '转账中',
                type: 'info',
              },
            ],
          },
          detail: false,
          width: '',
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          detail: false,
          width: '',
        },
      ],
      formFields: {
        addTitle: '添加订单',
        updateTitle: '修改订单',
        model: [{}],
      },
      operate: [
        {
          icon: 'el-icon-success',
          type: 'text',
          text: '转账',
          exist: (row) => {
            return (
              row.status !== 1 &&
              this.$refs.table.havePermission('usdtFee:transfer')
            )
          },
          handle: (row) => {
            if (row.status == 1) {
              message.warning('已转账')
              return
            }

         /*   this.$prompt('请输入验证码', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
            })*/
              // .then(({ value }) => {
                // console.log(value)
               /* if (!value) {
                  this.$message.warning('验证码不能为空')
                  return
                }*/

                this.$axios.post({
                  url: '/usdtFee/transfer/' + row.id /*+ '/' + value*/,
                  data: {},
                  confirm: `确定转账吗？`,
                  success: (res) => {
                    console.log(res)
                    if (res.code === 0) {
                      this.$message.success('操作成功')
                      this.$refs.table.getData()
                    } else {
                      this.$message.error(res.msg || `操作失败`)
                    }
                  },
                })/*
              })
              .catch((res) => {
                console.log(res)
                this.$message.info('取消')
              })*/
          },
        },
        {
          icon: 'el-icon-s-finance',
          type: 'text',
          text: '修改金额',
          exist: (row) => {
            return (
                row.status !== 1 &&
                this.$refs.table.havePermission('usdtFee:transfer')
            )
          },
          handle: (row) => {
            if (row.status == 1) {
              message.warning('已转账')
              return
            }

            this.$prompt('请输入修改金额', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
            })
                .then(({ value }) => {
                  console.log(value)
                  if (!value) {
                    this.$message.warning('修改金额不能为空')
                    return
                  }

                  this.$axios.post({
                    url: 'usdtFee/updateMoney/' + row.id + '/' + value,
                    data: {},
                    confirm: `确定修改吗？`,
                    success: (res) => {
                      console.log(res)
                      if (res.code === 0) {
                        this.$message.success('操作成功')
                        this.$refs.table.getData()
                      } else {
                        this.$message.error(res.msg || `操作失败`)
                      }
                    },
                  })
                })
                .catch((res) => {
                  console.log(res)
                  this.$message.info('取消')
                })
          },
        },
      ],
      buttons: [
        /*{
                    icon: 'el-icon-download',
                    type: 'warning',
                    text: '导出',
                    permission: 'recharge:export',
                    click: () => {
                        this.tableColumns.some(item => {
                            if (item.field == 'agentId') {
                                this.agents = item.selectData;
                            }
                        })
                        this.exportVisible = true;
                    }
                }*/
      ],
    }
  },
  methods: {
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.get({
            url: '/recharge/export',
            data: this.form,
            confirm: '确定导出Excel？',
            //responseType: 'arraybuffer',
            success: (res) => {
              if (res.code === 0) {
                message.success('充值导出任务正在进行中')
                this.exportVisible = false
              } else {
                message.error(res.msg)
              }
              /*if (res.code) {
                  message.error(res.msg);
                  return;
              }
              excelDownload(res, "充值明细导出.xlsx");
              /!*this.$msgbox({
                  title: '下载地址',
                  message: '下载地址为：' + res.data + '，点击确定跳转下载！'
              }).then(() => {
                  window.open(res.data,"_blank");
              }).catch()*!/
              this.exportVisible = false;*/
            },
          })
        }
      })
    },
  },
}
</script>

<style scoped>
</style>
